import { useEffect, useRef } from 'react';

const PUB_ID = 'ca-pub-8403725637689927';

const config = {
  banner:    { style: { display: 'block', width: '100%', minHeight: 90 },  slot: '1234567890' },
  sidebar:   { style: { display: 'block', width: 160,   minHeight: 600 },  slot: '1234567891' },
  rectangle: { style: { display: 'block', width: '100%', minHeight: 250 }, slot: '1234567892' },
};

export default function AdSlot({ type = 'banner' }) {
  const ref = useRef(null);

  useEffect(() => {
    try {
      if (ref.current && ref.current.offsetWidth > 0) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {}
  }, []);

  const { style, slot } = config[type] || config.banner;

  return (
    <div style={{ overflow: 'hidden', textAlign: 'center' }} ref={ref}>
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client={PUB_ID}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
